
import {Component} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import CheckboxYesNo from '@/components/common/CheckboxYesNo.vue'
import {requiredIf, email} from 'vuelidate/lib/validators'
import ContactModel from '@/models/ContactModel'
import {FaRating} from 'vue-rate-it'
import ThumbsUp from 'vue-rate-it/glyphs/thumbs-up'
import convertTelNumberDirective from '@/directives/convertTelNumberDirective'
import {isCoprolibTelNumber} from '@/helpers/validators'

@Component({
  components: {
    BaseFormContainer,
    SelectRef,
    FaRating,
    CheckboxYesNo
  },
  directives: {
    convertTelNumberDirective
  },
  validations: {
    form: {
      NOM: {
        required: requiredIf((form) => {
          return !form.EMAIL && !form.TELEPHONE1 && !form.TELEPHONE2
        })
      },
      EMAIL: {
        required: requiredIf((form) => {
          return !form.NOM && !form.TELEPHONE1 && !form.TELEPHONE2
        }),
        email
      },
      TELEPHONE1: {
        required: requiredIf((form) => {
          return !form.NOM && !form.EMAIL && !form.TELEPHONE2
        }),
        isCoprolibTelNumber
      },
      TELEPHONE2: {
        required: requiredIf((form) => {
          return !form.NOM && !form.TELEPHONE1 && !form.EMAIL
        }),
        isCoprolibTelNumber
      }
    }
  }
})
export default class ContactForm extends BaseForm {
  model = ContactModel
  thumbsUp = null

  get icon() {
    return this.thumbsUp
  }

  created() {
    this.thumbsUp = ThumbsUp
  }
}
